import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      d: "M18 20q-.825 0-1.412-.587A1.93 1.93 0 0 1 16 18v-3q0-.825.588-1.412A1.93 1.93 0 0 1 18 13q.825 0 1.413.588T20 15v3q0 .825-.587 1.413A1.92 1.92 0 0 1 18 20m-6 0q-.825 0-1.412-.587A1.93 1.93 0 0 1 10 18V6q0-.824.588-1.412A1.93 1.93 0 0 1 12 4q.825 0 1.413.588T14 6v12q0 .825-.587 1.413A1.92 1.92 0 0 1 12 20m-6 0q-.824 0-1.412-.587A1.93 1.93 0 0 1 4 18v-7q0-.825.588-1.412A1.93 1.93 0 0 1 6 9q.825 0 1.413.588T8 11v7q0 .825-.587 1.413A1.92 1.92 0 0 1 6 20"
    }, null, -1)
  ]))]))
}
export default { render: render }